<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <div v-if="selectedModel">
      <custom-select
        v-model="selectedModel"
        :options="options"
        :searchable="true"
        :filterable="false"
        clear-search-on-select="true"
        @input="onChange"
        @open="onOpen"
        @close="onClose"
        @search="onSearch"
      >
        <template slot-scope="{ option }">
          <div class="lang-selector">
            <div
              class="lang-selector__dot-color"
              :style="`--lang-selector-dot-color: ${
                option.color != null ? option.color : 'var(--gray)'
              }`"
            />
            {{ option.title }}
          </div>
        </template>
        <template #footer>
          <li
            v-show="showLoader"
            ref="load"
            class="select-tag__loader text-muted"
          >
            Загрузка...
          </li>
        </template>
      </custom-select>
      <input
        name="language"
        type="hidden"
        :value="selectedModel ? selectedModel.id : null"
      />
    </div>
    <div v-else>
      <pacman-loader
        size="15"
        style="position: relative !important"
      />
    </div>
  </div>
</template>

<script>
import referenceService from '@shared/services/reference.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
// eslint-disable-next-line import/no-unresolved
import CustomSelect from './custom-select';
import sharedComponentsMessages from '../sharedComponentsMessages';

export default {
  name: 'ProjectLanguageSelector',
  components: { PacmanLoader, CustomSelect },
  props: {
    selectedLanguageId: { default: 296 },
    selectedLanguageTitle: { default: 'Markdown' },
    redirect: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: [],
      selectedModel: {
        id: 296,
        title: 'Markdown'
      },
      pages: [],
      observer: null,
      nextPage: 1,
      showLoader: true
    };
  },
  computed: {
    hasNextPage() {
      return this.nextPage < this.pages.totalPages;
    }
  },
  mounted() {
    this.selectedModel.id = this.selectedLanguageId;
    this.selectedModel.title = this.selectedLanguageTitle;
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.$emit('input', this.selectedModel);
  },
  methods: {
    searchLangs($event) {
      referenceService
        .getLangs({
          q: $event,
          size: 50
        })
        .then((res) => {
          this.options = res.items;
        });
    },
    getOptions(callback) {
      referenceService.getLangs({ page: this.nextPage }).then((res) => {
        this.options.push(...res.items);
        this.pages = res.page;
        this.nextPage = this.pages.number + 1;
        if (callback) {
          callback();
        }
      });
    },
    onChange(e) {
      this.$emit('input', e);
      if (!this.redirect) return;
      const params = new URLSearchParams(window.location.search);
      params.set('language', e.id);
      window.location.search = params.toString();
    },
    async onOpen() {
      await this.$nextTick();

      referenceService.getLangs().then((res) => {
        this.options = res.items;
        this.pages = res.page;
        this.observer.observe(this.$refs.load);
      });
    },
    onClose() {
      this.observer.disconnect();
      this.setDefault();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const { scrollTop } = ul;

        const setScroll = () => {
          this.$nextTick(() => {
            ul.scrollTop = scrollTop;
          });
        };

        if (this.hasNextPage) {
          this.getOptions(setScroll);
        } else {
          this.showLoader = false;
        }
      }
    },
    onSearch(q) {
      if (q) {
        setTimeout(() => {
          this.observer.disconnect();
          referenceService.getLangs({ q }, false).then((res) => {
            this.options = res.items;
            this.showLoader = false;
          });
        }, 500);
      }
    },
    setDefault() {
      this.nextPage = 1;
      this.options = [];
      this.showLoader = true;
      this.observer.disconnect();
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>

<style lang="scss" scoped>
.lang-selector {
  display: flex;
  align-items: center;

  &__dot-color {
    width: 10px;
    height: 10px;
    margin-right: 10px;
    border-radius: 100%;
    flex-shrink: 0;
    background: var(--gray);
    background-color: var(--lang-selector-dot-color);
  }
}
</style>
